// ============================================================================
// ROLE PERMISSIONS ENDPOINTS - Digital Approval System
// ============================================================================
// URL builders for /admin/role-permissions API.
// ============================================================================

import { appendQueryParams, buildEndpoint, buildEndpointWithParams } from '../base.endpoints';
import type { ID } from '../../types';
import type { RolePermissionFilterParams } from '../../types/admin/rolePermissions.types';

const BASE_PATH = '/admin/role-permissions';

export const rolePermissionsEndpoints = {
  /** GET /admin/role-permissions?page=&pageSize=&searchTerm=&activeOnly= */
  list: (params?: RolePermissionFilterParams) =>
    appendQueryParams(buildEndpoint(BASE_PATH), params ?? {}),

  /** GET /admin/role-permissions/{id} */
  getById: (id: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** GET /admin/role-permissions/by-roles?roles=code1,code2,... */
  getByRoles: (rolesCsv: string) =>
    appendQueryParams(buildEndpoint(`${BASE_PATH}/by-roles`), { roles: rolesCsv }),

  /** POST /admin/role-permissions */
  create: () => buildEndpoint(BASE_PATH),

  /** PUT /admin/role-permissions/{id} */
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),

  /** DELETE /admin/role-permissions/{id} */
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
};
